import React from 'react';

import { Icon } from '@chakra-ui/react';

export const PolicyRoleIcon = props => (
  <Icon viewBox="0 0 2480 2475" w="full" h="full" color="inherit" {...props}>
    <g transform="translate(-962 0)">
      <g>
        <g>
          <g>
            <g>
              <path
                d="M1375.5 2206.88 1375.5 268.125C1375.5 233.952 1403.2 206.25 1437.37 206.25L2638.94 206.25C2655.34 206.25 2671.08 212.769 2682.68 224.373L3007.38 549.064C3018.98 560.669 3025.5 576.407 3025.5 592.817L3025.5 2206.88C3025.5 2241.05 2997.8 2268.75 2963.62 2268.75L1437.37 2268.75C1403.2 2268.75 1375.5 2241.05 1375.5 2206.88Z"
                stroke="currentColor"
                strokeWidth="68.75"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="4"
                strokeOpacity="1"
                fill="none"
                fillRule="nonzero"
              />
              <path
                d="M2613 556.875 2613 242.71C2613 222.574 2629.32 206.25 2649.46 206.25 2659.13 206.25 2668.4 210.091 2675.25 216.929L3014.82 556.509C3021.66 563.346 3025.5 572.62 3025.5 582.29 3025.5 602.426 3009.18 618.75 2989.03 618.75L2674.87 618.75C2640.7 618.75 2613 591.048 2613 556.875Z"
                stroke="currentColor"
                strokeWidth="68.75"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="4"
                strokeOpacity="1"
                fill="currentColor"
                fillRule="nonzero"
                fillOpacity="1"
              />
            </g>
          </g>
        </g>
        <g>
          <g>
            <g>
              <path
                d="M2530 1142.45 2530 1134.87C2530 952.621 2382.25 804.875 2200 804.875 2017.75 804.875 1870 952.621 1870 1134.87L1870 1142.45C1822.05 1159.5 1787.5 1204.82 1787.5 1258.62 1787.5 1313.32 1823.23 1359.2 1872.44 1375.56 1889.88 1542.59 2030.48 1671.03 2200 1671.12 2369.52 1671.02 2510.11 1542.58 2527.56 1375.56 2576.77 1359.2 2612.5 1313.33 2612.5 1258.62 2612.5 1204.82 2577.95 1159.5 2530 1142.45ZM2217.1 1629.37C2066.14 1638.34 1935.63 1529.46 1914.65 1382.37L2485.45 1382.37C2466.23 1516.86 2354.9 1621.19 2217.1 1629.37ZM2488.75 1341.12 1911.25 1341.12C1865.69 1341.12 1828.75 1304.19 1828.75 1258.62 1828.75 1213.06 1865.69 1176.12 1911.25 1176.12L2014.38 1176.12C2025.77 1176.12 2035 1166.89 2035 1155.5 2035 1144.11 2025.77 1134.87 2014.38 1134.87L1911.25 1134.87C1911.25 1011.79 1988.4 906.975 2096.88 865.423L2096.88 1052.37C2096.88 1052.38 2096.88 1052.39 2096.88 1052.4 2096.88 1063.78 2106.11 1073.01 2117.5 1073 2117.51 1073 2117.52 1073 2117.52 1073 2128.91 1072.99 2138.13 1063.76 2138.12 1052.37L2138.12 852.938C2158.08 848.577 2178.74 846.125 2200 846.125 2221.26 846.125 2241.92 848.577 2261.88 852.938L2261.88 1052.37C2261.88 1052.38 2261.88 1052.39 2261.88 1052.4 2261.88 1063.78 2271.11 1073.01 2282.5 1073 2282.51 1073 2282.52 1073 2282.52 1073 2293.91 1072.99 2303.13 1063.76 2303.12 1052.37L2303.12 865.423C2411.6 906.975 2488.75 1011.79 2488.75 1134.87L2385.62 1134.87C2374.24 1134.87 2365 1144.11 2365 1155.5 2365 1166.89 2374.24 1176.12 2385.62 1176.12L2488.75 1176.12C2534.31 1176.12 2571.25 1213.06 2571.25 1258.62 2571.25 1304.19 2534.31 1341.12 2488.75 1341.12Z"
                stroke="currentColor"
                strokeWidth="33.2773"
                strokeLinecap="butt"
                strokeLinejoin="miter"
                strokeMiterlimit="4"
                strokeOpacity="1"
                fill="currentColor"
                fillRule="nonzero"
                fillOpacity="1"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </Icon>
);
